import axios from "axios";
import Input from "./Form/Input"
import { useToast } from "./UI/useToast";
import { useEffect, useRef, useState } from "react";
import { APIURL } from "..";
import Loading from "./UI/Loading";
import Form from './Form/Form'
import parse from 'html-react-parser'
import Dropdown from "./Form/Dropdown";
import Checkbox from "./Form/Checkbox";

const Formular = ({name="cards", title="", text="", className=''}) => {
    const { addToast } = useToast();
    const [formData, setFormData] = useState();
    const ref = useRef();
    const handleSubmit = (data) => {
        var dataForm = formData?.inputs.map((d, i) => ({ id: d.id, value: d.type==='select'?data[d.name].map(v=>v.label).join(","):data[d.name] }));
        axios
            .post(APIURL + "/newAnswer", {data: dataForm, name,language: "cs"})
            .then((response) => {
                addToast({type: "success",message: "Váš požadavek byl odeslán."});
                ref.current?.reset();
            })
            .catch((err) => {
                addToast({type: "error",message:"Nastala se chyba, kontaktujte nás prosím na admin@agenturagen.cz."});
            });
    };
    const getForm = async () => {
        await axios
            .post(APIURL + "/form", { name, language: "cs" })
            .then((response) => {setFormData(response.data.body)});
    };
    useEffect(() => {
        getForm();
    }, []);

    if (!formData) {return <Loading />} 
    else return (
        <div className={"flex justify-between mobil:flex-col "+className} id="form" >
            <div className="nemobil:w-1/2 p-14 mobil:p-7 flex flex-col justify-between bg-purplee-500 rounded-xl text-white">
                <h2 className="m-0">{title}</h2>
                <div>{parse(text)}</div>
            </div>
            <div className="bg-white rounded-xl nemobil:w-1/2 p-14 mobil:p-7">
                <Form onSubmit={handleSubmit} ref={ref}> 
                    {formData?.inputs?.map((input, index) =>
                        (input.type === "input" || input.type === "textarea") ? (
                        <Input
                            key={input.id}
                            label={input.label}
                            name={input.name}
                            placeholder={input.placeholder}
                            className={`${(input.type === "textarea"||input.input_type==="number") ? "" : "half"}`}
                            required={input.required ? true : false}
                            type={input.input_type}
                        />
                        ) :
                        (input.type === "select")?(
                            <Dropdown 
                                key={input.id}
                                label={input.label}
                                name={input.name}
                                placeholder={input.placeholder}
                                options={input.options}
                                isMulti={input.multiple}
                                className="half"
                            />
                        ):<></>
                    )}
                    <Checkbox name="GDPR" className="basis-full text-sm pt-7 pb-4" required>Souhlasím s <a href="/Lorem-ipsum-GDPR.pdf">GDPR</a></Checkbox>
                    <button type="submit" className="workshop">Odjednat</button>
                </Form>
            </div>
        </div>
    )
}

export default Formular